import { useParams } from "react-router-dom";
import { useState } from "react";
import "./ProductDetails.css";

const PRODUCTS = [
  {
    id: 1,
    title: "Switch, 48 × 10Gb SFP+, with 8 × 100Gb QSFP28",
    price: "US$4,199.00",
    img: "/images/products/product-01.png",
    thumbs: [
      "/images/products/product-01.png",
      "/images/products/product-02.png",
      "/images/products/product-03.png",
    ],
  },
  {
    id: 2,
    title: "Switch, 32 × 100Gb QSFP28",
    price: "US$7,999.00",
    img: "/images/products/product-02.png",
    thumbs: [
      "/images/products/product-02.png",
      "/images/products/product-03.png",
    ],
  },
];

export default function ProductDetails() {
  const { id } = useParams();
  const product = PRODUCTS.find(p => p.id === Number(id));
  const [mainImg, setMainImg] = useState(product.img);
  const [zoom, setZoom] = useState(false);

  return (
    <section className="nx-section">
      <div className="container nx-pd-grid">

        {/* LEFT */}
        <div className="nx-image-box">
          <img
            src={mainImg}
            className="nx-main-img"
            onClick={() => setZoom(true)}
          />

          <div className="nx-thumbs">
            {product.thumbs.map((t, i) => (
              <img key={i} src={t} onClick={() => setMainImg(t)} />
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="nx-pd-right">
          <h1>{product.title} <span className="nx-hot">Hot</span></h1>

          <div className="nx-price-box">
            <span className="nx-price">{product.price}</span>
          </div>

          <ul className="nx-info">
            <li>✔ 169 in Global Warehouse</li>
            <li>✔ Deliver to India</li>
            <li>✔ 5-Year Warranty · 30-Day Returns</li>
          </ul>

          <div className="nx-cart-row">
            <input type="number" defaultValue={1} />
            <button>Add to Cart</button>
          </div>
        </div>

        {/* IMAGE ZOOM MODAL */}
        {zoom && (
          <div className="nx-modal" onClick={() => setZoom(false)}>
            <img src={mainImg} />
          </div>
        )}

      </div>
    </section>
  );
}
